// export const API_URL = "http://localhost:4000"

export const API_URL = "https://dronelabs.zuppa.io:4000"